import React, { useState } from 'react';
import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import styles from './Profile.module.css';
import userAvatarPlaceholder from '../../../../assets/images/other/user_avatar_placeholder.png';
import { getTimeAgo } from '../../../../utils/formatHelpers';
import { UnPaidModal } from '../UnpaidUserModal/UnpaidUserModal';
import { EmployerViewProfileDownload, MailBlueIcon, Message, TopRightArrow, VerifyBadge, VerifyGreenBadge, backgroundImgEmployerView, filledStar, unfilledStar, } from '../../../../assets/images/icons';
import { createChatroom } from '../../../../services/chatService';

function Profile({ jobseeker, isEmployer, setActiveTab, blur, handleBlur, setHandleBlur }) {
    let latestWorkExperience = null;
    const userData = useSelector((state) => state.user.user);
    const user = useSelector(state => state.user.user);
    if (jobseeker?.work_experiences?.length) {
        jobseeker.work_experiences.forEach((experience) => {
            if (!latestWorkExperience || new Date(experience.startdate) > new Date(latestWorkExperience.startdate)) {
                latestWorkExperience = experience;
            }
        });
    }

    const cvFile =
        jobseeker?.primary_cv_file ||
        jobseeker?.cv_file ||
        jobseeker?.cv_file_0;

    const handleDownloadCV = () => {
        if (cvFile) {
            const fileUrl = `${process.env.REACT_APP_UPLOADS_PATH}${cvFile}`;
            window.open(fileUrl, '_blank'); // Open the CV file in a new tab
        }
    };
    let is_online = false;
    const date_info = getTimeAgo(new Date(jobseeker?.last_visit));
    if (date_info.unit_plural !== 'month' && date_info.unit_plural !== 'months' && date_info.unit_plural !== 'year' && date_info.unit_plural !== 'years') {

        if (date_info.unit_plural === 'second' || date_info.unit_plural === 'seconds' || date_info.unit_plural === 'minute' || (date_info.unit_plural === 'minutes' && date_info.count < 5)) {
            is_online = true;
        }
        else {
        }

    }
    const navigate = useNavigate();
    const handleMessage = async () => {
        const employerId = userData.account_type == 'employer' ? userData?.id : jobseeker?.id
        const jobSeekerId = userData.account_type !== 'employer' ? userData?.id : jobseeker?.id
        if (employerId && jobSeekerId) {
            await createChatroom(employerId, jobSeekerId);
            navigate('/chat', {
                state: {
                    employerId,
                    jobSeekerId,
                }
            })
        }

    }
    return (
        <div className={styles.container}>
            {handleBlur && <UnPaidModal onClose={() => setHandleBlur(false)} />}
            <div className={handleBlur ? styles.blur : styles.wrapper}>
                <div className={styles.bgImg}>
                    <img
                        style={{ height: `110%`, width: `106vw` }}
                        className={styles.BgImg}
                        src={backgroundImgEmployerView}
                        alt={t('EmployerViewProfile.rating_start')}
                    />
                </div>
                <div className={styles.profileImageContainer}>
                    <img
                        className={ styles.profileImage}
                        // className={jobseeker?.hide_Profile_Picture ? styles.profileImageBlur : styles.profileImage}
                        src={jobseeker?.hide_Profile_Picture ? userAvatarPlaceholder : jobseeker?.profile_image ? `${process.env.REACT_APP_UPLOADS_PATH}${jobseeker?.profile_image}` : userAvatarPlaceholder}
                        onError={(e) => {
                            e.target.onerror = null; // Prevent infinite loop
                            e.target.src = userAvatarPlaceholder; // Set fallback image
                        }}
                        alt={`${jobseeker?.first_name} ${jobseeker?.last_name}`}
                    />
                    {is_online && <div className={styles.onlineStatus}></div>}
                </div>
                <div className={`${styles.title} ${styles.centerImg}`} style={{ fontSize: '24px', }}>
                    {isEmployer ? jobseeker?.company_name : jobseeker?.first_name + jobseeker?.last_name}

                    {isEmployer ?
                        jobseeker.subscriptionStatus == 'active' &&
                        <img src={VerifyGreenBadge} alt={t('EmployerViewProfile.verified')} className={styles.image} />
                        :
                        jobseeker?.verification_status === 'approved' && (
                            <img src={VerifyBadge} alt={t('EmployerViewProfile.verified')} className={styles.image} />
                        )}
                </div>
                <p className={`${styles.companyName} ${styles.subHeadingContainer}`} style={{ textTransform: 'uppercase', }} >
                    {latestWorkExperience?.position}
                </p>
                <div className={styles.subHeadingWrapper}>
                    {latestWorkExperience?.employmentStatus &&
                        <>
                            <p className={`${styles.companyName} ${styles.subHeadingContainer}`} >
                                <span className={styles.subHeading} >
                                    {t('EmployerViewProfile.employment_status') + ': '}
                                </span>
                                {t('forms.workExperience.employment_status.' + `${latestWorkExperience?.employmentStatus}`)}
                            </p>
                            <p className={`${styles.companyName} ${styles.subHeadingContainer}`} >
                                <span className={styles.subHeading} >
                                    {t('EmployerViewProfile.hired_on') + ': '}
                                </span>
                                {latestWorkExperience?.startDate}
                            </p>
                        </>
                    }
                </div>
                {isEmployer &&
                    <div className={styles.ratingContainer}>
                        {[0, 0, 0, 0, 0].map((_, index) => {
                            return <img src={index < 3 ? filledStar : unfilledStar} alt={t('EmployerViewProfile.verified')} />
                        })}
                        <p className={`${styles.companyName} ${styles.subHeadingContainer}`} >
                            <span className={styles.subHeading} style={{ color: '#FECE0E' }}>
                                4.7
                            </span>
                        </p>
                        <p className={`${styles.companyName} ${styles.subHeadingContainer}`} >
                            <span className={styles.subHeading} style={{ color: '#6D6D6D', textDecorationLine: "underline" }}>
                                (76)
                            </span>
                        </p>
                    </div>
                }
                <div>
                    <div className={styles.buttonContainer}>
                        {/* {isEmployer && */}
                        <>
                            {userData?.account_type !== 'employer' &&
                                <button
                                    className={styles.messageButtonDark}
                                    onClick={async () => {
                                        if (user?.verification_status === 'approved' && user?.subscriptionStatus == 'active') {
                                            if (jobseeker.id && userData.id) {
                                                await createChatroom(jobseeker.id, userData.id);
                                                navigate('/chat', {
                                                    state: {
                                                        employerId: jobseeker.id,
                                                        jobSeekerId: userData.id,
                                                    }
                                                })
                                            }
                                        } else {
                                            setHandleBlur(true)
                                        }
                                    }}

                                >
                                    <img src={Message} alt={t('EmployerViewProfile.download_CV')} />
                                    {t('EmployerViewProfile.message')}
                                </button>
                            }
                            {jobseeker?.company_website &&
                                <div
                                    onClick={() => {
                                        if (user?.verification_status === 'approved' && user?.subscriptionStatus == 'active') {
                                            window.open(jobseeker.company_website, '_blank')
                                        } else {
                                            if (userData?.account_type !== 'employer') {
                                                setHandleBlur(true)
                                            } else {
                                                if (user?.subscriptionStatus == 'active') {
                                                    window.open(jobseeker.company_website, '_blank')
                                                } else {
                                                    setHandleBlur(true)
                                                }
                                            }
                                        }
                                    }}
                                    className={styles.seeAllButtonContainer}>
                                    <p className={styles.seeAllButton}>{t(`EmployerViewProfile.visit_company_website`)}</p>
                                    <img src={TopRightArrow} alt="arrow icon" className={styles.arrowIcon} />
                                </div>
                            }
                        </>
                        {/* } */}
                        {userData?.account_type == 'employer' &&
                            jobseeker?.jobseeker_status &&
                            <button onClick={handleMessage} className={styles.messageButton}>
                                <img src={MailBlueIcon} alt={t('EmployerViewProfile.message')}
                                    style={{ filter: 'brightness(0) saturate(100%) invert(23%) sepia(81%) saturate(444%) hue-rotate(202deg) brightness(96%) contrast(95%)' }} />
                                {t('EmployerViewProfile.message')}
                            </button>
                        }
                        {cvFile ? (
                            <button
                                className={styles.messageButtonDark}
                                onClick={handleDownloadCV}
                            >
                                <img src={EmployerViewProfileDownload} alt={t('EmployerViewProfile.download_CV')} />
                                {t('EmployerViewProfile.download_CV')}
                            </button>
                        ) : null}
                    </div>
                </div>
            </div>

        </div>
    );
}

export default Profile;
